module.exports = __webpack_public_path__ + "static/media/(000026).20ba8a6d.jpg";